try{self['workbox:sw:5.1.4']&&_()}catch(e){}// eslint-disable-line